
define('text!gameInterfaces/GameInterfacesShell.html',[],function () { return '<div class="router" data-bind="router: {}"></div>\n';});

